import React, { useState } from 'react';
import { RxCross2 } from 'react-icons/rx';
import ReactQuill from 'react-quill';

const CombinedSummaryModal = ({ ismodal, setIsModal, quillSummary, imagingdata }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  if (!ismodal || (!quillSummary && !imagingdata)) return null;

  const renderData = (data) => {
    if (Array.isArray(data)) {
      return data.map((item, index) => (
        <div key={index} className="mb-6 border border-gray-300 p-4 rounded-lg">
          {renderData(item)}
        </div>
      ));
    }

    return (
      <div>
        {Object.entries(data).map(([key, value], index) => (
          <div key={index} className="mb-4 flex items-start">
            <strong className="capitalize text-gray-900 text-sm font-semibold mr-2">
              {key.replace(/([A-Z])/g, ' $1')}:
            </strong>
            {typeof value === 'object' ? (
              <div className="ml-2 border-l-4 border-gray-300 pl-4 space-y-3">
                {renderData(value)}
              </div>
            ) : (
              <span className="text-gray-700 text-sm">
                {value?.toString() || (
                  <span className="text-gray-400 italic font-light">N/A</span>
                )}
              </span>
            )}
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
        <div className="relative bg-white p-6 rounded-xl shadow-2xl w-full max-w-3xl overflow-y-auto max-h-[90vh] animate-fade-in custom-scrollbar">
          <button onClick={() => setIsModal(false)} className="absolute top-4 right-4 text-gray-500 hover:text-gray-800">
            <RxCross2 size={28} />
          </button>

          <h2 className="text-xl font-semibold text-gray-800 mb-6 text-start">Summary Details</h2>

          {/* Show Quill Summary if available */}
          {quillSummary && (
            <div className="mb-8">
              <h3 className="text-lg font-medium mb-2 text-start text-gray-800">Visit Summary</h3>
              <ReactQuill
                className="w-full text-start flex-grow custom-scrollbar p-2 font-inter"
                style={{
                  borderRadius: "8px",
                  border: "1px solid #A2C6FD",
                  background: "#FFF",
                  boxShadow: "0px 5px 15px 0px rgba(119, 132, 238, 0.30)",
                  minHeight: "200px",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                }}
                value={quillSummary}
                readOnly={true}
                modules={{ toolbar: false }}
              />
            </div>
          )}

          {/* Show Imaging Summary if available */}
          {imagingdata?.summary && (
            <div className="mb-8">
              <h3 className="text-lg font-medium mb-2 text-start text-gray-800">Imaging Summary</h3>
              {renderData(imagingdata.summary)}
            </div>
          )}

          {/* Show Images if available */}
          {imagingdata?.images?.length > 0 && (
            <div className="mt-6">
              <h3 className="text-lg font-medium mb-2 text-start text-gray-800">Images</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {imagingdata.images.map((image, index) => (
                  <img
                    key={index}
                    src={`data:${image[0]};base64,${image[1]}`}
                    alt={`Image ${index + 1}`}
                    className="rounded-lg shadow-md cursor-pointer hover:scale-105 transition-transform duration-300"
                    onClick={() => setSelectedImage(`data:${image[0]};base64,${image[1]}`)}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Enlarged Image Modal */}
      {selectedImage && (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
          <button onClick={() => setSelectedImage(null)} className="absolute top-4 right-4 text-white text-2xl">
            <RxCross2 size={32} />
          </button>
          <img src={selectedImage} alt="Enlarged" className="max-w-full max-h-full p-4 rounded-lg" />
        </div>
      )}
    </>
  );
};

export default CombinedSummaryModal;
